import { $api } from "../generated/client";

export default function useShopifySegments(shopId: string | undefined) {
  return $api.useQuery("get", "/shops/{shopId}/shopify-segments", {
    params: { path: { shopId: shopId! } },
  }, {
    enabled: !!shopId,
  });
}
